import React from 'react';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const quickLinks = [
        { name: 'Services', href: '#services' },
        { name: 'Projects', href: '#projects' },
        { name: 'About', href: '#about' },
        { name: 'Contact', href: '#contact' },
    ];

    return (
        <footer style={{
            backgroundColor: '#0A0A0A',
            color: 'rgba(255,255,255,0.6)',
            fontSize: '0.9rem',
            position: 'relative'
        }}>
            {/* Subtle top gradient border */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.08), rgba(59,130,246,0.15), rgba(255,255,255,0.08), transparent)',
                pointerEvents: 'none'
            }} />

            {/* Main Footer Content */}
            <div className="container footer-container" style={{ padding: '4rem 1.5rem 2rem' }}>
                <div className="footer-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1.5fr',
                    gap: '4rem',
                    paddingBottom: '3rem',
                    borderBottom: '1px solid rgba(255,255,255,0.06)'
                }}>
                    {/* Column 1: Brand */}
                    <div>
                        <div style={{
                            fontWeight: 800,
                            fontSize: '1.1rem',
                            color: '#4E9A06',
                            textTransform: 'uppercase',
                            letterSpacing: '0.1em',
                            marginBottom: '1rem'
                        }}>
                            AUTOMACHINA
                        </div>
                        <p style={{
                            color: 'rgba(255,255,255,0.4)',
                            fontSize: '0.95rem',
                            lineHeight: 1.7,
                            maxWidth: '320px',
                            fontWeight: 300
                        }}>
                            Intelligence, Humanized.
                        </p>
                        <div style={{
                            display: 'flex',
                            gap: '0.5rem',
                            marginTop: '1.25rem'
                        }}>
                            <span style={{
                                width: '32px',
                                height: '2px',
                                background: 'linear-gradient(90deg, rgba(59,130,246,0.6), transparent)',
                                borderRadius: '1px',
                                marginTop: '0.5rem'
                            }} />
                            <p style={{
                                color: 'rgba(255,255,255,0.3)',
                                fontSize: '0.8rem',
                                lineHeight: 1.6,
                                fontWeight: 400,
                                maxWidth: '280px'
                            }}>
                                AI-first solutions. Custom models. Enterprise scale.
                            </p>
                        </div>
                    </div>

                    {/* Column 2: Quick Links */}
                    <div>
                        <div style={{
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            color: 'rgba(255,255,255,0.35)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.12em',
                            marginBottom: '1.25rem'
                        }}>
                            Quick Links
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            {quickLinks.map((link) => (
                                <a
                                    key={link.name}
                                    href={link.href}
                                    className="footer-link"
                                    style={{
                                        color: 'rgba(255,255,255,0.5)',
                                        fontSize: '0.9rem',
                                        textDecoration: 'none',
                                        transition: 'color 0.3s ease',
                                        fontWeight: 400
                                    }}
                                >
                                    {link.name}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Column 3: Contact */}
                    <div>
                        <div style={{
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            color: 'rgba(255,255,255,0.35)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.12em',
                            marginBottom: '1.25rem'
                        }}>
                            Contact
                        </div>
                        <a
                            href="mailto:lets.connect@automachina.tech"
                            className="footer-link"
                            style={{
                                color: 'rgba(255,255,255,0.5)',
                                fontSize: '0.9rem',
                                textDecoration: 'none',
                                transition: 'color 0.3s ease',
                                fontWeight: 400
                            }}
                        >
                            lets.connect@automachina.tech
                        </a>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingTop: '2rem',
                    flexWrap: 'wrap',
                    gap: '1rem'
                }}>
                    <p style={{
                        color: 'rgba(255,255,255,0.3)',
                        fontSize: '0.8rem',
                        margin: 0
                    }}>
                        &copy; {new Date().getFullYear()} AutoMachina&trade;. All Rights Reserved.
                    </p>

                    {/* Back to Top */}
                    <button
                        onClick={scrollToTop}
                        className="back-to-top-btn"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            background: 'rgba(255,255,255,0.05)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            color: 'rgba(255,255,255,0.4)',
                            padding: '0.5rem 1rem',
                            borderRadius: '100px',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.08em',
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
                        }}
                    >
                        Back to Top
                        <ArrowUp size={14} />
                    </button>
                </div>
            </div>

            <style>{`
                .footer-link:hover {
                    color: #FFFFFF !important;
                }
                .back-to-top-btn:hover {
                    background: rgba(255,255,255,0.1) !important;
                    color: rgba(255,255,255,0.8) !important;
                    border-color: rgba(255,255,255,0.15) !important;
                    transform: translateY(-2px);
                }
                @media (max-width: 768px) {
                    .footer-container {
                        padding: 3rem 1.25rem 2rem !important;
                    }
                    .footer-grid {
                        grid-template-columns: 1fr !important;
                        gap: 2.5rem !important;
                    }
                }
            `}</style>
        </footer>
    );
};

export default Footer;
